module.exports = __webpack_public_path__ + "e0bc5ae5a4ebb7f55dd660c323db37e5.png";